import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { take } from 'rxjs/operators';

@Component({
    templateUrl: './not-found.component.html',
})
export class NotFoundComponent implements OnInit {
    basePath = window.location.href.split('#')[0];
    path = this.route.snapshot.url[0];
    url = `${this.basePath}#/${this.path}`;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.route.data.pipe(take(1)).subscribe(data => {
            this.path = data.path;
        });
    }
}
